/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import { createApp } from 'vue';

/**
 * Next, we will create a fresh Vue application instance. You may then begin
 * registering components with the application instance so they are ready
 * to use in your application's views. An example is included for you.
 */

const registerCommonComponents = (app) => {
    app.component('buscador', require('./components/buscador.vue').default);
    app.component('carrito', require('./components/carrito.vue').default);
    app.component('favoritos', require('./components/favoritos.vue').default);
    app.component('menu-usuario', require('./components/menu-usuario.vue').default);
    app.component('estadisticas', require('./components/estadisticas/EstadisticasVisitas.vue').default);
};
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// Object.entries(import.meta.glob('./**/*.vue', { eager: true })).forEach(([path, definition]) => {
//     app.component(path.split('/').pop().replace(/\.\w+$/, ''), definition.default);
// });

/**
 * Finally, we will attach the application instance to a HTML element with
 * an "id" attribute of "app". This element is included with the "auth"
 * scaffolding. Otherwise, you will need to add an element yourself.
 */

const rootAppElement = document.getElementById('app');
if (rootAppElement) {
    const app = createApp({});
    registerCommonComponents(app);
    app.mount('#app');
}

const wompiCheckoutElement = document.getElementById('checkout-wompi-app');
if (wompiCheckoutElement) {
    const checkoutApp = createApp({});
    checkoutApp.component('checkout-wompi-panama', require('./components/checkout/WompiPanamaCheckout.vue').default);
    checkoutApp.mount('#checkout-wompi-app');
}

const checkoutPageElement = document.getElementById('checkout-app');
if (checkoutPageElement) {
    const rawProps = checkoutPageElement.getAttribute('data-props') || '{}';
    let initialData = {};

    try {
        initialData = JSON.parse(rawProps);
    } catch (error) {
        initialData = {};
    }

    const checkoutPageApp = createApp({
        components: {
            CheckoutPage: require('./components/checkout/CheckoutPage.vue').default,
        },
        data() {
            return {
                initialData,
            };
        },
        template: '<checkout-page :initial-data="initialData" />',
    });

    checkoutPageApp.mount('#checkout-app');
}

const mailingAdminElement = document.getElementById('mailing-admin-app');
if (mailingAdminElement) {
    const rawProps = mailingAdminElement.getAttribute('data-props') || '{}';
    let mailingProps = {};

    try {
        mailingProps = JSON.parse(rawProps);
    } catch (error) {
        mailingProps = {};
    }

    const mailingAdminApp = createApp({
        components: {
            MailingBuilder: require('./components/mailing/mailing-builder.vue').default,
        },
        data() {
            return {
                mailingProps,
            };
        },
        template: '<mailing-builder v-bind="mailingProps" />',
    });

    mailingAdminApp.mount('#mailing-admin-app');
}
